import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';
import CircleCheckIcon from '../../assets/svg_components/CircleCheckIcon';
import PaymentSuccessfulStyle from './PaymentSuccessful.module.scss';
import useCustomQuery from '../../network/useCustomQuery';
import { VALIDATE_TRANSACTION_PUBLIC } from '../../graphql/queries';
import Button from '../../components/Button';
import CautionIcon from '../../assets/svg_components/CautionIcon';

const PaymentSuccessfulV2 = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const transactionId =
    queryParams?.get('transactionId')?.split('?')[0] || queryParams?.get('transactionId');
  const navigate = useNavigate();

  const [validateTransactionPublic, loading, trxData] = useCustomQuery({
    query: VALIDATE_TRANSACTION_PUBLIC,
    onError: () => {},
    onData: () => {}
  });

  useEffect(() => {
    if (transactionId) {
      validateTransactionPublic({
        variables: {
          transactionId
        }
      });
    }
  }, [transactionId]);

  useEffect(() => {
    window?.postMessage?.({ event: 'payfi-mod-cls' }, '*');
  }, []);

  if (loading) {
    return (
      <div className={PaymentSuccessfulStyle?.wrapper}>
        <Loader />
      </div>
    );
  }

  if (
    trxData?.validateTransactionPublic?.status !== 200 ||
    !trxData?.validateTransactionPublic ||
    trxData?.validateTransactionPublic?.data?.status === 'failed' ||
    !trxData?.validateTransactionPublic?.data?.paymentLink
  ) {
    return (
      <div className={PaymentSuccessfulStyle?.wrapper}>
        <div className={PaymentSuccessfulStyle?.wrapper__Container}>
          <div className={PaymentSuccessfulStyle?.wrapper__icon}>
            <CautionIcon width="100px" height="100px" fillColor="#E31D1C" />
          </div>
          <div className={PaymentSuccessfulStyle?.wrapper__title}>Payment in progress</div>
          <div className={PaymentSuccessfulStyle?.wrapper__subtitle}>
            Something went wrong with the transaction. Click to continue payment in dashboard
          </div>
          <div className={PaymentSuccessfulStyle?.wrapper__amount}>
            <Button
              title="Go to Dashboard"
              color="primary"
              type="submit"
              width="fit-content"
              padding="10px 24px"
              onPress={() => {
                navigate('/dashboard/rent-payment/all?page=1');
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  // const paymentlink = trxData?.validateTransactionPublic?.data?.paymentLink;
  if (trxData?.validateTransactionPublic?.data?.status !== 'success') {
    // pending
    return (
      <div className={PaymentSuccessfulStyle?.wrapper}>
        <div className={PaymentSuccessfulStyle?.wrapper__Container}>
          <div className={PaymentSuccessfulStyle?.wrapper__icon}>
            <Loader height="120px" />
          </div>
          <div className={PaymentSuccessfulStyle?.wrapper__title}>Payment pending</div>
          <div className={PaymentSuccessfulStyle?.wrapper__subtitle}>
            Your transaction is processing. You will be notified once it is completed.
          </div>
          {/* <div className={PaymentSuccessfulStyle?.wrapper__amount}>
            <Button
              title="Continue payment"
              color="primary"
              type="submit"
              width="fit-content"
              padding="10px 24px"
              onPress={() => {
                // go to payment link
                // window.open(paymentlink);
                window.location.href = paymentlink;
              }}
            />
          </div> */}
        </div>
      </div>
    );
  }

  return (
    <div className={PaymentSuccessfulStyle?.wrapper}>
      <div className={PaymentSuccessfulStyle?.wrapper__Container}>
        <div className={PaymentSuccessfulStyle?.wrapper__icon}>
          <CircleCheckIcon fillColor="#5941A9" width="100px" height="100px" />
        </div>
        <div className={PaymentSuccessfulStyle?.wrapper__title}>Payment Successful</div>
        <div className={PaymentSuccessfulStyle?.wrapper__subtitle}>
          Your transaction has been completed successfully.
        </div>
        <div className={PaymentSuccessfulStyle?.wrapper__amount}>
          Amount paid: ${trxData?.validateTransactionPublic?.data?.amount}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessfulV2;
